<template>
	<section class="posts border-top-none">
		<article v-for="(project,index) in sofareisenProjects" :key="index">
			<header>
				<span class="date">{{project.country}}</span>
				<h2><router-link :to="'/project/'+project.id">{{project.title}}</router-link></h2>
			</header>
			<router-link :to="'/project/'+project.id" class="image fit"><img alt="Projekt Cover" :src="project.cover" /></router-link>
			<p>{{project.teaser}}</p>
			<ul class="actions special">
				<li><router-link class="button" :to="'/project/'+project.id">Mehr erfahren</router-link></li>
			</ul>
		</article>

    <!-- Default -->
    <RTProjectEmptyDefault/>
	</section>
</template>

<script>
import RTProjectEmptyDefault from '@/components/RTProjectEmptyDefault.vue'
import {helper} from '@/mixins/helper.js'
import {projectBase} from '@/mixins/projectBase.js'
export default {
  name: 'RTProject',
  mixins:[helper,projectBase],
  props:{

  },
  components: {
    RTProjectEmptyDefault
  },
  data: function() {
    return {
    };
  },
  watch:{
  },
  computed:{
  },
  methods:{
  },
  /*
  beforeRouteEnter: (to,from,next) => {
		next(() => {
       setTimeout(()=>{
				window.scrollTo(0, 0);
			},300);
		});
  },
  */
  created() {
  },
  destroyed() {
  },
};
</script>

<style scoped type='text/css'>
</style>